import {default as _} from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { Subscription } from 'rxjs';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { SharedHttpClientService } from '../../../Shared/Services/shared-http-client.service';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { UserService } from '../../../Shared/Services/user.service';
import { ButtonModule } from 'primeng/button';
import { TableModule,Table } from 'primeng/table';
import { FilterPanelComponent } from "../../../Shared/Component/filter-panel/filter-panel.component";
import { CurrencyPipe, DatePipe, DecimalPipe, NgClass,CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BaseChartDirective } from "ng2-charts";
import { ChartConfiguration } from 'chart.js';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-cat-billing',
    templateUrl: './cat-billing.component.html',
    styleUrls: ['./cat-billing.component.scss'],
    imports: [ButtonModule, TableModule, FilterPanelComponent, NgClass, CommonModule, MatProgressSpinnerModule,
        DatePipe, DecimalPipe, CurrencyPipe, BaseChartDirective, ToastModule
    ]
})
export class CatBillingComponent implements OnInit, OnDestroy {
  @ViewChild(('dt')) dt!: Table;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | any;
  msgs!: any[];
  tbldatamsg = "L o a d i n g . . . . .";
  reportDate: any;
  LastExecutionCATDate!: any[];
  DefaultFilterArray: any = [];
  selectedTabIndex: number = 1;
  venueTab: boolean = true;
  monthTab: boolean = false;
  venueGraphDataLoadingResults = false;
  monthlyGraphDataLoadingResults = false;
  venueSummaryDetail: any = [];
  monthlyChartDetail: any = [];
  monthlySummaryDetail: any = [];
  
  private subscription!: Subscription;

  public venueTabularColumns: any = [
    { field: 'Execution Venue', header: 'Execution Venue' }, 
    { field: 'Billing Shares', header: 'Billing Shares' }
  ];
  public executionVenues: any = [];

  public venueChartType: string = "bar";
  public venueChartLegend: boolean = true;
  public venueChartLabels: Array<any> = [];

  public venueChartDatasets: Array<any> = [];
  public venueChartOptions: Object = new Object();
  public venueChartColor: Array<any> = [];

  public monthlyChartType: string = "bar";
  public monthlyChartLegend: boolean = true;
  public monthlyChartLabels: Array<any> = [];

  public monthlyChartDatasets: Array<any> = [];
  public monthlyChartOptions: Object = new Object();
  public monthlyChartColor: Array<any> = [];

  public chartData: ChartConfiguration<any>['data'] = {
    labels: this.monthlyChartLabels,
    datasets: this.monthlyChartDatasets
  }

  public venueChartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.venueChartLabels,
    datasets: this.venueChartDatasets
  }

  constructor(
    private emitterService: EmitterService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    public constantService: ConstantService,
    private userService: UserService) {
  }

  ngOnInit(): void {
    this.initialChartData(); // Set Initial Chart Data

    /*** Get Last CAT Execution date*/
    let todate: any;
    todate = this.userService.CATLastExecutionDate;
    this.LastExecutionCATDate = [];
    if (todate != "" || todate != undefined || todate != null) {
      this.LastExecutionCATDate[0] = (todate);
      this.LastExecutionCATDate[1] = (todate);
      this.defaultFilter();
    }
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
  }

  initialChartData() {
    /* Venue Graph Data */
      this.venueChartDatasets = [
        {
          data: this.venueChartDatasets,
          barPercentage: 0.3,
          label: 'Billing Shares',
          backgroundColor:'rgba(68, 114, 196, 0.6)'
        }
      ];     

      this.venueChartOptions = {
        legend: { display: false, position: 'bottom' },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: 
            { beginAtZero: true }          
        },
        plugins: {         
          datalabels: { 
           display: false
          },
          legend: {
            position: 'bottom'
          }
        },
      };

      this.venueChartColor = [
        {
          backgroundColor: 'rgba(68, 114, 196, 0.6)',
          borderColor: 'rgba(68, 114, 196, 0.6)',
          HoverBackgroundColor: 'rgba(68, 114, 196, 0.6)',
          HoverBorderColor: 'rgba(68, 114, 196, 0.6)'
        }
      ];
    /* End of Venue Graph Data */

    /* Monthly Graph Data */
      this.monthlyChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        type: 'line',
        tension:0.5,
        tooltips: {
          callbacks: {
            label: function (tooltipItem: any) {
              return ((tooltipItem.datasetIndex === 1) ? (new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
              })).format(tooltipItem.value) : tooltipItem.value);
            }
          }
        },
        scales: {
          y: 
            {beginAtZero: true,
               position: 'left',              
               backgroundcolor:'rgba(68, 114, 196, 0.6)',
               title: {
                display: true,
                text: 'Billing Shares',}
            },
            y1: 
            {beginAtZero: true,
            position: 'right',
            title: {
              display: true,
              text: 'Billing Amount',},
              backgroundcolor:'rgba(242, 38, 19, 0.7)',
              ticks: { callback: (value:any) => value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) },
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
            },            
          },
          plugins: {         
            datalabels: { 
             display: false
            },
            legend: {
              position: 'bottom'
            }
          },
      };

      this.monthlyChartColor = [
        {
          backgroundColor: 'rgba(68, 114, 196, 0.6)',
          borderColor: 'rgba(68, 114, 196, 0.6)',
          HoverBackgroundColor: 'rgba(68, 114, 196, 0.6)',
          HoverBorderColor: 'rgba(68, 114, 196, 0.6)'
        },
        {
          backgroundColor: 'rgba(242, 38, 19, 0.7)',
          borderColor: 'rgba(242, 38, 19, 0.7)',
          pointBackgroundColor: 'rgba(242, 38, 19, 0.7)',
          pointBorderColor: 'rgba(242, 38, 19, 0.7)',
          pointHoverBackgroundColor: 'rgba(242, 38, 19, 0.7)',
          pointHoverBorderColor: 'rgba(242, 38, 19, 0.7)'
        }
      ];
    /* End of Monthly Graph Data */
  }

  getOptedTab(tabIndex: number, tabText: string) {
    this.venueTab =  (tabText.includes('ByVenue') ? true : false);
    this.monthTab = (tabText.includes('Month') ? true : false);

    this.selectedTabIndex = tabIndex;
  }

  FilterApplyFilterEvent(event:any) {
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.getData();
  }

  defaultFilter() {
    if (this.reportDate) {
      this.LastExecutionCATDate = [];
      this.LastExecutionCATDate.push(this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.reportDate)));
      this.LastExecutionCATDate.push(this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.reportDate)));
    }

    this.DefaultFilterArray = [
      { "isdefault": "true", "label": "Date", "columnname": "reportDate", "filterby": "IS", "values": this.LastExecutionCATDate, "time": "", "datatype": "DateRange", "disabled": "true", "dropdown": "", "dropdownvalue": "" }
    ];

    this.getData();
  }

  getData() {
    this.tbldatamsg = "L o a d i n g . . . . .";
    this.getChartData("ByVenue");
    this.getChartData("Monthly");
  }

  getChartData(chartType?: string) {
    const defaultFilters = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    defaultFilters[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFilters[0].values[0])));
    defaultFilters[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFilters[0].values[1])));

    this.reportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(this.DefaultFilterArray[0].values[0])));
    let payload = {
      data: defaultFilters,
      mpid: this.userService.getActiveMPID(),
      chartDataType: chartType,
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate)
    }

    if(chartType==="ByVenue") {
      this.executionVenues = [];
      this.venueChartLabels = [];
      this.venueSummaryDetail = [];
      this.venueGraphDataLoadingResults = true;

      this.sharedHttpClientService.post(
        this.urlsService.setAPIURl(
          APIURL.CAT_BILLING
        ), payload
      )
      .subscribe({
        next: (Element: any) => {
          this.venueGraphDataLoadingResults = false;
          let dataset: any = Element;
          if (dataset.length === 0) {
            this.tbldatamsg = "No data found";
          } else {
            if(dataset.VenueChartData.length === 0) {
              this.tbldatamsg = "No data found";

              this.venueChartLabels = ['']; // Venue Chart Labels
              this.venueChartDatasets = [{...this.venueChartDatasets[0], data: [0]}]; // Venue Chart DataSet
              
              this.venueChartData= {
                labels: this.venueChartLabels,
                datasets:this.venueChartDatasets
              }
            }
            if(dataset.VenueChartData.length > 0) {
              /* Prepare Data for Venue with Venue Total BillingShares */
              const venueWithTotalBillingSharesTabularData =  dataset.VenueChartData.map((rowObj:any) => {
                return {
                  executionvenue: rowObj.execution_venue,
                  billingshares: parseFloat(rowObj.venueWiseTotalBillingShares).toLocaleString()
                }
              });

              /* Prepare Chart Data Arrays for Venues & Venue with Venue Total BillingShares */
              const execution_Venues = dataset.VenueChartData.map((rowObj:any) => `${rowObj.execution_venue}`);
              const venueWiseTotalBillingShares = dataset.VenueChartData.map((rowObj:any) => `${rowObj.venueWiseTotalBillingShares}`);

              this.executionVenues = venueWithTotalBillingSharesTabularData; // Venue with Billing Shares Table Data
              this.venueChartLabels = [...execution_Venues]; // Venue Chart Labels
              this.venueChartDatasets = [{...this.venueChartDatasets[0], data: venueWiseTotalBillingShares}]; // Venue Chart DataSet
            }
            if(dataset.VenueSummaryData.length > 0) {
              this.venueSummaryDetail = dataset.VenueSummaryData[0]; // Venue Summary Details
            }
          }
          this.venueChartData= {
            labels: this.venueChartLabels,
            datasets:this.venueChartDatasets
          }
          this.venueGraphDataLoadingResults = false;
        },
        error: (err: HttpErrorResponse) => {
          this.tbldatamsg = "No data found";
          this.venueGraphDataLoadingResults = false;
        }
      });
    } else if(chartType==="Monthly") {
      this.monthlyChartLabels = [];
      this.monthlyChartDetail = [];
      this.monthlySummaryDetail = [];
      this.monthlyGraphDataLoadingResults = true;

      this.sharedHttpClientService.post(
        this.urlsService.setAPIURl(
          APIURL.CAT_BILLING
        ), payload
      )
      .subscribe({
        next: (Element: any) => {
          let dataset: any = Element;
          const monthlyBillingAmountPointRadius:any[] = [], monthlyReportDateWiseTotalBillingShares:any[] = [], monthlyReportDateWisesTotalBillingAmount:any[] = [];

          if (dataset.length === 0) {
            this.tbldatamsg = "No data found";
          } else {
            const wholeMonthReportDates = this.userService.getAllWorkingDatesOfMonth(new Date(this.reportDate).getUTCFullYear(), new Date(this.reportDate).getUTCMonth()); // Get all Working Days of First selected Date of Month

            if (dataset.MonthlyChartData.length === 0) {
              this.monthlyChartLabels = [...wholeMonthReportDates]; // Monthly Chart Labels
              this.monthlyChartDatasets = [{ ...this.monthlyChartDatasets[0] }, { ...this.monthlyChartDatasets[1] }]; // Monthly Chart DataSet
              
              this.monthlyChartLabels = [...wholeMonthReportDates]; // Monthly Chart Labels
              this.monthlyChartDatasets = [
                { ...this.monthlyChartDatasets[0], data: monthlyReportDateWiseTotalBillingShares },
                { ...this.monthlyChartDatasets[1], data: monthlyReportDateWisesTotalBillingAmount, pointRadius: monthlyBillingAmountPointRadius }
              ]; // Monthly Chart DataSet
              this.chartData = {
                labels: this.monthlyChartLabels,
                datasets: [{data:monthlyReportDateWiseTotalBillingShares,yAxisID: 'y',label: 'Billing Shares', backgroundColor:'rgba(68, 114, 196, 0.6)',borderColor:'rgba(68, 114, 196, 0.6)'},
                  {data:monthlyReportDateWisesTotalBillingAmount,yAxisID: 'y1',label: 'Billing Amount',type: 'line',backgroundColor: 'rgba(242, 38, 19, 0.7)',borderColor: 'rgba(242, 38, 19, 0.7)',}
                ]
              }
            }
            if (dataset.MonthlyChartData.length > 0) {
              if (wholeMonthReportDates.length > 0) {
                for (let i = 0; i < wholeMonthReportDates.length; i++) {
                  const searchedReportDate = dataset.MonthlyChartData.filter((rowObj: any) => rowObj.reportdate === wholeMonthReportDates[i]);
                  if (searchedReportDate.length > 0) {
                    monthlyBillingAmountPointRadius.push(2);
                    monthlyReportDateWiseTotalBillingShares.push(searchedReportDate[0].reportDateWiseTotalBillingShares);
                    monthlyReportDateWisesTotalBillingAmount.push(searchedReportDate[0].billingAmount);
                  } else {
                    monthlyBillingAmountPointRadius.push(0);
                    monthlyReportDateWiseTotalBillingShares.push(0);
                    monthlyReportDateWisesTotalBillingAmount.push(0);
                  }
                }
              }
              this.monthlyChartLabels = [...wholeMonthReportDates]; // Monthly Chart Labels
              this.monthlyChartDatasets = [
                { ...this.monthlyChartDatasets[0], data: monthlyReportDateWiseTotalBillingShares },
                { ...this.monthlyChartDatasets[1], data: monthlyReportDateWisesTotalBillingAmount, pointRadius: monthlyBillingAmountPointRadius }
              ]; // Monthly Chart DataSet
              this.chartData = {
                labels: this.monthlyChartLabels,
                datasets: [{data:monthlyReportDateWiseTotalBillingShares,yAxisID: 'y',label: 'Billing Shares', backgroundColor:'rgba(68, 114, 196, 0.6)',borderColor:'rgba(68, 114, 196, 0.6)'},
                  {data:monthlyReportDateWisesTotalBillingAmount,yAxisID: 'y1',label: 'Billing Amount',type: 'line',backgroundColor: 'rgba(242, 38, 19, 0.7)',borderColor: 'rgba(242, 38, 19, 0.7)',}
                ]
              }
            }
            if (dataset.MonthlySummaryData.length > 0) {
              this.monthlySummaryDetail = dataset.MonthlySummaryData[0];
            }
          }         
          this.monthlyGraphDataLoadingResults = false;
        },
        error: (err: HttpErrorResponse) => {
          this.monthlyGraphDataLoadingResults = false;
        }
      });
    }
  }

  getGraphChartHeight() {
    let barGraphHeight = 0;

    if(screen.availHeight <= 770) {
      barGraphHeight = 440;
    } else if(window.innerHeight <= 910 && window.innerHeight > 770) {
      barGraphHeight = 580;
    } else if(window.innerHeight <= 1100 && window.innerHeight > 910) {
      barGraphHeight = 770;
    } else if(window.innerHeight <= 1320 && window.innerHeight > 1100) {
      barGraphHeight = 980;
    }

    return barGraphHeight;
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

}